import { Routes } from '@angular/router';
import { ArchiveComponent } from './pages/archive/archive.component';
import { ArticleComponent } from './pages/article/article.component';
import { SidebarLayoutComponent } from './layouts/sidebar-layout/sidebar-layout.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { HomeComponent } from './pages/home/home.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { ContentManagementComponent } from './pages/content-management/content-management.component';
import { MsalGuard } from '@azure/msal-angular'
import { contentEditAccessGuard } from './shared/services/content-edit-access.guard';

export enum EPagesPath {
  home = '',
  contacts = 'contacts',
  article = 'codedetails/:codeId',
  contentManagement = 'content-management',
  archive = 'archive',
}

export const routes: Routes = [
  {
    path: EPagesPath.home,
    component: HomeComponent,
    canActivate:[MsalGuard] 
  },
  {
    path: EPagesPath.contacts,
    component: ContactsComponent,
    canActivate:[MsalGuard] 
  },
  {
    path: EPagesPath.contentManagement,
    loadChildren: () => import('./pages/content-management/content-management.module').then(m => m.ContentManagementModule),
    canActivate:[MsalGuard, contentEditAccessGuard]
  },
  {
    path: EPagesPath.archive,
    loadChildren: () => import('./pages/archive/archive.module').then(m => m.ArchiveModule),
    canActivate:[MsalGuard, contentEditAccessGuard]
  },
  {
    path: EPagesPath.article,
    component: ArticleComponent,
    canActivate:[MsalGuard] 
  },
  {
    path: '**',
    redirectTo: EPagesPath.home,
    pathMatch: 'full',
  },
];
